import { Address } from '@/types/request';

/**
 * @author <Aniket.P>
 * @description Map utils
 * @copyright Supra International, inc
 */
export class MapUtils {

    public static parseGoogleAddress(googleAddress: any): Address {
        const place = googleAddress.getPlace();
        const addressComponenets = place.address_components;
        const zipComponent = this.findComponent(addressComponenets, 'postal_code');
        const countryComponent = this.findComponent(addressComponenets, 'country');
        const stateComponent = this.findComponent(addressComponenets, 'administrative_area_level_1');
        const cityComponent = this.findComponent(addressComponenets, 'locality');
        const countyComponent = this.findComponent(addressComponenets, 'administrative_area_level_2');
        const subpremiseComponent = this.findComponent(addressComponenets, 'subpremise');
        const subLocalityComponent = this.findComponent(addressComponenets, 'sublocality');
        const address: Address = {
            fullAddress: place.formatted_address,
            latitude: place.geometry.location.lat(),
            longitude: place.geometry.location.lng(),
            zip: zipComponent ? zipComponent.long_name : undefined,
            country: countryComponent ? countryComponent.long_name : undefined,
            city: cityComponent ? cityComponent.long_name : undefined,
            state: stateComponent ? stateComponent.long_name : undefined,
            subLocality: subLocalityComponent ? subLocalityComponent.long_name : undefined,
            county: countyComponent ? countyComponent.long_name : undefined,
            // Keeping locality and subpremise for now for compatibility.
            locality: subpremiseComponent ? subpremiseComponent.long_name : undefined,
            subpremise: subpremiseComponent ? subpremiseComponent.long_name : undefined,
        };
        return address;
    }

    private static findComponent(addressComponenets: any[], componentId: string): any {
        let result;
        addressComponenets.forEach((addressComponenet) => {
            if (addressComponenet.types.indexOf(componentId) >= 0) {
                result = addressComponenet;
            }
        });
        return result;
    }

}
